export const GA4_SESSION_KEY = 'Ga4Session';

export const Ga4SellerType = Object.freeze({
  Private: 'private',
  Shop: 'shop',
});

export const Ga4AddressType = Object.freeze({
  Private: 'private',
  LegalEntity: 'legal_entity',
});

export const Ga4ProfileSection = Object.freeze({
  MyAds: 'my_ads',
  MyOrders: 'my_orders',
  MyCards: 'my_cards',
  ShopOrders: 'shop_orders',
  MyAuction: 'my_auction',
  SentOffers: 'sent_offers',
  MyFinances: 'my_finances',
  IncomingOffers: 'incoming_offers',
  Messages: 'messages',
  MyAddresses: 'my_addresses',
  Courier: 'courier',
  MyBankAccounts: 'my_bank_accounts',
  MyShop: 'my_shop',
  MyFavourites: 'my_favourites',
  MyCart: 'my_cart',
  EditAccount: 'edit_account',
});

export const Ga4VisibilitySource = Object.freeze({
  PostCreation: 'post_creation',
  MyAds: 'my_ads',
  Promo: 'promo',
});

export const Ga4UpgradeType = Object.freeze({
  Vip: 'vip',
  VipPlus: 'vip_plus',
  SuperVip: 'super_vip',
  ColorHighlight: 'color_highlight',
  AutoRenewal: 'auto_renewal',
});

export const Ga4PaymentMethod = Object.freeze({
  SavedCard: 'saved_card',
  NewCard: 'new_card',
  ApplePay: 'apple_pay',
  GooglePay: 'google_pay',
  TbcMobilebank: 'tbc_mobilebank',
});

export const Ga4OrderSide = Object.freeze({
  Buyer: 'buyer',
  Seller: 'seller',
});

export const Ga4OrderFilterType = Object.freeze({
  Status: 'status',
  Period: 'period',
  Search: 'search',
});

export const Ga4OrderStatus = Object.freeze({
  0: 'placed',
  1: 'being_processed',
  2: 'in_transit',
  3: 'delivered',
  4: 'cancelled',
  5: 'refunded',
  7: 'invoice_to_send',
  8: 'invoice_sent',
  9: 'invoice_cancelled',
  12: 'cancelled_refund_pending',
  13: 'installment_requested',
  14: 'installment_approved',
  15: 'installment_issued',
  16: 'installment_closed_by_customer',
  17: 'installment_rejected_by_system',
  18: 'installment_processing',
  19: 'meet_seller_pending',
  20: 'meet_seller_delivered',
  21: 'meet_seller_cancelled',
  22: 'ready_to_deliver',
  23: 'installment_being_filled',
  24: 'not_in_stock',
  25: 'meet_seller_placed',
  26: 'meet_seller_processing',
  27: 'meet_seller_ready',
  28: 'meet_seller_not_in_stock',
  29: 'express_delivery_placed',
  30: 'express_delivery_processing',
  31: 'express_delivery_ready',
  32: 'express_delivery_cancelled',
  33: 'express_delivery_delivered',
  35: 'bnpl_approved',
  36: 'order_late',
  37: 'shop_delivery_placed',
  38: 'shop_delivery_in_transit',
  39: 'return_under_review',
});

export const Ga4MyAdsTab = Object.freeze({
  Active: 'active',
  Expired: 'expired',
  Disabled: 'disabled',
  Drafts: 'drafts',
});

export const Ga4OrgType = Object.freeze({
  Ltd: 'ltd',
  GeneralPartnership: 'general_partnership',
  IndividualEntrepreneur: 'individual_entrepreneur',
  LimitedPartnership: 'limited_partnership',
  Jsc: 'jsc',
  Cooperative: 'cooperative',
  Nonprofit: 'nonprofit',
  PublicLawEntity: 'public_law_entity',
});

export const Ga4OrgTypeLegalFormId = Object.freeze({
  1: Ga4OrgType.Ltd,
  2: Ga4OrgType.GeneralPartnership,
  3: Ga4OrgType.IndividualEntrepreneur,
  4: Ga4OrgType.LimitedPartnership,
  5: Ga4OrgType.Jsc,
  6: Ga4OrgType.Cooperative,
  7: Ga4OrgType.Nonprofit,
  8: Ga4OrgType.PublicLawEntity,
});

export const Ga4ListingConfigType = Object.freeze({
  SellOnline: 'sell_online',
  DeliveryExpress: 'delivery_express',
});

export const Ga4ListingType = Object.freeze({
  Sell: 'sell',
  Buy: 'buy',
  Rent: 'rent',
  Services: 'services',
  Auction: 'auction',
});

export const Ga4ListingStepPhase = Object.freeze({
  Reached: 'section_reached',
  Engaged: 'section_engaged',
  Complete: 'section_complete',
});

export const Ga4HeaderNavItem = Object.freeze({
  Installments: 'installments',
  Shops: 'shops',
  Sale: 'sale',
  GiveAway: 'give_away',
  OpenShop: 'open_shop',
  Help: 'help',
  Blog: 'blog',
  Contact: 'contact',
});

export const Ga4ShopEditField = Object.freeze({
  LegalData: 'legal_data',
  About: 'about',
  Address: 'address',
  Contact: 'contact',
  WarrantyPolicy: 'warranty_policy',
  AuctionTerms: 'auction_terms',
  BankAccount: 'bank_account',
  Logo: 'logo',
  CourierService: 'courier_service',
});

export const Ga4ListingStep = Object.freeze({
  ListingTypeCategory: Object.freeze({ name: 'listing_type_category', number: 1 }),
  Photos: Object.freeze({ name: 'photos', number: 2 }),
  Price: Object.freeze({ name: 'price', number: 3 }),
  AuctionSetup: Object.freeze({ name: 'auction_setup', number: 4 }),
  SellOnWebsite: Object.freeze({ name: 'sell_on_website', number: 5 }),
  MainFeatures: Object.freeze({ name: 'main_features', number: 6 }),
  WarrantyPolicy: Object.freeze({ name: 'warranty_policy', number: 7 }),
  TitleDescription: Object.freeze({ name: 'title_description', number: 8 }),
  DeliveryContact: Object.freeze({ name: 'delivery_contact', number: 9 }),
  AuctionHandover: Object.freeze({ name: 'auction_handover', number: 10 }),
  Promotion: Object.freeze({ name: 'promotion', number: 11 }),
});
